import "./App.css";
import Navbar from "./Components/Navbar";
import "@fontsource/tajawal";
import "@fontsource/tajawal/700.css";
import Cars from "./Components/Cars";
import BookingPage from "./Components/BookingPage";
import Footer from "./Components/Footer";
import AirportTransfers from "./Components/Ourservices/AirportTransfers";
import Menusectionpage from "./Components/Menusectionpage";
import Aboutuspage from "./Components/Aboutuspage";
import Contactuspage from "./Components/Contactuspage";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Homepage from "./Components/Homepage";
import Businesscardpage from "./Components/Businesscardpage";
import Chauffertransfer from "./Components/Ourservices/Chauffertransfer";
import EventTransportation from "./Components/Ourservices/EventTransportation";
import Citytocitytransfer from "./Components/Ourservices/Citytocitytransfer";
import Hirebythehour from "./Components/Ourservices/Hirebythehour";
import Loginpage from "./Components/Loginpage";
import OwnerPage from "./Components/OwnerPage";
import Registerpage from "./Components/Registerpage";
import DashboardChart from "./Components/DashboardChart";
import { useEffect } from "react";
import TermsConditions from "./Components/TermsConditions";
import Privacy from "./Components/privacy";
import Deliverypolicy from "./Components/Deliverypolicy";
import CookiePolicy from "./Components/Cookiepolicy";
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();
  const hideLayout = location.pathname.startsWith("/ownerpage");

  return (
    <>
      <ScrollToTop />
      {!hideLayout && <Navbar />}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/bookingpage" element={<BookingPage />} />
        <Route path="/contact" element={<Contactuspage />} />
        <Route path="/Airporttransfers" element={<AirportTransfers />} />
        <Route path="/chauffer" element={<Chauffertransfer />} />
        <Route path="/citytocity" element={<Citytocitytransfer />} />
        <Route path="/hirebythehour" element={<Hirebythehour />} />
        <Route path="/eventtransportation" element={<EventTransportation />} />
        <Route path="/cars" element={<Cars />} />
        <Route path="/about" element={<Aboutuspage />} />
        <Route path="/business" element={<Businesscardpage />} />
        <Route path="/aboutus" element={<Menusectionpage />} />
        <Route path="/loginpage" element={<Loginpage />} />
        <Route path="/register" element={<Registerpage />} />
        <Route path="/dashboard" element={<DashboardChart />} />
        <Route path="/ownerpage" element={<OwnerPage />} />
        <Route path="/terms&conditions" element={<TermsConditions />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/deliverypolicy" element={<Deliverypolicy />} />
        <Route path="/cookiepolicy" element={<CookiePolicy />} />
      </Routes>
      {!hideLayout && <Footer />}
 
    </>
  );
}
function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
export default App;

